// Time-zone names and labels (4.3d.4), shared by the picker, the setup wizard and the settings card.
export const TZ_OPTIONS = (() => {
  try { return Intl.supportedValuesOf("timeZone"); }
  catch { return ["UTC", "Asia/Amman", "Asia/Riyadh", "Asia/Dubai", "Asia/Beirut", "Africa/Cairo", "Europe/London", "Europe/Paris", "America/New_York", "America/Sao_Paulo"]; }
})();

// The zone the person setting up is in — the starting value, never assumed to be UTC.
export const browserZone = () => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"; } catch { return "UTC"; } };

// "Asia/Amman · GMT+3"
export function tzLabel(tz) {
  try {
    const offset = new Intl.DateTimeFormat("en", { timeZone: tz, timeZoneName: "shortOffset" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value ?? "";
    return offset ? `${String(tz).replace(/_/g, " ")} · ${offset}` : String(tz).replace(/_/g, " ");
  } catch { return String(tz ?? ""); }
}
